//Licens duration dropdown API: http://local.nti.dk/api/productapi/getproductdurationdropdown/productId/licenseType

if ($('.product-page').length > 0) {

    var getUrl = window.location,
        baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0],
        productId = $('.product-page').attr('data-productid'),
        language = $('html').attr('lang');

    $('#license-type').on('change', function() {
        $(this).children(':selected').attr('selected', 'selected').siblings().removeAttr('selected');

        var licenseType = $('#license-type option:selected').val(),
            durationUrl = baseUrl + 'api/productapi/getproductdurationdropdown/' + productId + '/' + licenseType + '/' + language;

        $.get(durationUrl, function(data) {
            $('.form-group.license-length').html(data);
        });
    });

    $('.license-length').on('change', function() {
        $('#license-length').children(':selected').attr('selected', 'selected').siblings().removeAttr('selected');

        var variantCode = $('#license-length option:selected').val(),
            variantPriceUrl = baseUrl + 'api/productapi/getvariantprice/' + variantCode + '/' + language;

        $.get(variantPriceUrl, function(data) {
            $('#price').html(data);
            $('[data-js="add-to-basket"], [data-js="send-request"]').removeAttr('disabled');
        });
    });


}